if (!window.customElements.get("deployer-preorder")) {
    window.customElements.define(
      "deployer-preorder",
      class DeployerPreorder extends HTMLElement {
        constructor() {
          super();
          this.onWideBundleLoaded = this.onWideBundleLoaded.bind(this);
          this.onPriceChange = this.onPriceChange.bind(this);
        }
  
        connectedCallback() {
          document.addEventListener("widebundle:loaded", this.onWideBundleLoaded);
        }
  
        disconnectedCallback() {
          document.removeEventListener("widebundle:loaded", this.onWideBundleLoaded);
          document.removeEventListener("widebundle:price:change", this.onPriceChange);
        }
  
        onWideBundleLoaded() {
            /**
             * Appelé quand WideBundle a fini de mettre à jour son formulaire.
            */
            this.onPriceChange();
            document.removeEventListener("widebundle:price:change", this.onPriceChange);
            document.addEventListener("widebundle:price:change", this.onPriceChange);
        }
  
        onPriceChange() {
            const currentVariant = window.wideBundle.getSelectedVariant();
            const currentVariantMetafieldsData = this.findVariantMetafieldsById(currentVariant.id);
            const isPreorder = this.validatePreorderConditions(currentVariantMetafieldsData);
            const atcBtn = document.querySelector("#new-form-atc");
            const productForm = document.querySelector('.product-block form[action*="/cart/add"]')

            if(isPreorder == true){
                this.showPreorderLabel(true, currentVariantMetafieldsData.metafields.preorder_date);
                this.setPreorderProperty(productForm, true);
                if(!atcBtn) return;
                /**
                 * Solution dégueu mais pas d'autre choix car le bouton généré par WideBundle se met à jour 2 fois consécutives.
                 * La MutationObserver ne fonctionne donc pas dessus.
                */
               setTimeout(() => {
                   atcBtn.innerHTML = window.deployerAdapter.preorderLabel;
                }, 1000);
            } else {
                this.setPreorderProperty(productForm, false);
                this.showPreorderLabel(false, currentVariantMetafieldsData.metafields.preorder_date);
            }

        }

        getOrCreatePreorderInput(productForm) {
            if (!productForm) return null;

            let input = productForm.querySelector('.from-deployer-preorder');
            if (input) return input;

            const label = window.deployerAdapter?.preorderPropertyLabel;
            const value = window.deployerAdapter?.preorderPropertyValue;
            if (!label || !value) return null;

            input = document.createElement('input');
            input.type = 'hidden';
            input.className = 'from-deployer-preorder';
            input.name = `properties[${label}]`;
            input.value = value;
            input.disabled = true;
            productForm.appendChild(input);
            return input;
        }

        setPreorderProperty(productForm, isPreorder) {
            const input = this.getOrCreatePreorderInput(productForm);
            if (input) input.disabled = !isPreorder;
        }
          

        findVariantById(variantId) {
            const variants = this.querySelector('[data-variants]').innerHTML;
            const parsedState = Array.from(JSON.parse(variants));
    
            return parsedState.find((variant) => (variant.id === variantId))
        }

        findVariantMetafieldsById(variantId) {
          const variants = this.querySelector('[data-variants-metafields]').innerHTML;
          const parsedState = Array.from(JSON.parse(variants));

          return parsedState.find((variant) => (variant.id === variantId))
        }

        validatePreorderConditions(variantMetafieldsData) {
            const dateHasPassed = this.dateHasPassed(variantMetafieldsData.metafields.preorder_date);
            if (
                variantMetafieldsData.available == true
                && variantMetafieldsData.metafields.preorder_date != ""
                && dateHasPassed == false 
                && variantMetafieldsData.metafields.preorder_enable == true
            ) {
                return true;
            }
            return false;
        }

        dateHasPassed(date) {
            if(!date || date == "") return true;
            const today = new Date().toISOString().slice(0, 10);
            return date < today;
        }

        humanReadableDate(date) {
            const options = { weekday: "long", day: "numeric", month: "long" };
            const locale = document.documentElement.lang || 'en-US';
            return new Date(date).toLocaleDateString(locale, options);
        }
        
        showPreorderLabel(isPreorder, date) {
            const element = document.querySelector(".deployer-preorder__content");
            if (!element) return;
            
            isPreorder === true
                ? element.classList.remove("hidden") 
                : element.classList.add("hidden");
                        
            if(!date || date == "") return;
            const humanDate = this.humanReadableDate(date);
            element.innerHTML = element.innerHTML.replace('#date#', humanDate);
        }
          
    });
}
